export default {
	type: 'object',
	properties: {
		accountManagerUserId: { type: 'string' },
	},
	additionalProperties: false,
	required: ['accountManagerUserId'],
}
